import { Loader2 } from 'lucide-react'
import { useDatabaseWaking } from '@/shared/api/databaseWaking'

/** Non-blocking bottom-right card while serverless SQL resumes (API_INTEGRATION §4). */
export default function DatabaseWakingNotice() {
  const waking = useDatabaseWaking()
  if (!waking) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 right-4 z-[9997] flex max-w-xs items-start gap-2 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 shadow-lg animate-[slideIn_0.2s_ease-out]"
    >
      <Loader2 size={16} className="mt-0.5 shrink-0 animate-spin text-blue-600" />
      <p className="text-xs text-blue-800">Waking the database… this can take up to a minute.</p>
    </div>
  )
}
